import { render, staticRenderFns } from "./providers-list.vue?vue&type=template&id=57ec645d&"
import script from "./providers-list.vue?vue&type=script&lang=js&"
export * from "./providers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports